import React, { PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import Settings from '../../settings/Settings'
import { IGameSettings } from '../../../helpers/data/gameSettings'

const fadeIn = keyframes`
  0% {
    opacity: 0;
    animation-timing-function: ease-out;
  }
  100% {
    opacity: 1;
  }
`

const boxFadeIn = keyframes`
  0% {
    opacity: 0.1;
    transform: scale(0.95, 0.95);
    animation-timing-function: ease-out;
  }
  100% {
    transform: scale(1, 1);
    opacity: 1;
  }
`

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	animation: ${fadeIn} 0.5s;
	animation-fill-mode: both;
	background-color: rgba(21, 45, 57, 0.85);
	text-align: center;
	position: absolute;
	top: 0;
	left: 0;
	padding-top: 2.5px;
	padding-bottom: 2.5px;
`

const SettingsContainer = styled.div`
	max-width: 656px;
	width: 100%;
	max-height: 100%;
	animation: ${boxFadeIn} 0.5s 0.1s;
	animation-fill-mode: forwards;
	background-color: rgb(255, 255, 255);
	border-radius: 5px;
	display: inline-block;
	opacity: 0;
	overflow: auto;
	vertical-align: middle;

	@media (max-width: ${656}px) {
		border-radius: 0px;
	}
`
// This vertical line is to vertically align the settings container
const Line = styled.div`
	width: 0px;
	height: 100%;
	display: inline-block;
	vertical-align: middle;
`

interface ISettingsProps {
	settings: IGameSettings
	onSettingsSubmit: (settings: any) => void
}

class SplashTeacherSettings extends PureComponent<ISettingsProps> {
	render() {
		return (
			<Wrapper>
				<SettingsContainer>
					<Settings
						settings={this.props.settings}
						onSettingsSubmit={this.props.onSettingsSubmit}
					/>
				</SettingsContainer>
				<Line />
			</Wrapper>
		)
	}
}

export default SplashTeacherSettings
